import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { BetSlipProvider } from "@/context/BetSlipContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SportPage from "@/pages/SportPage";
import Live from "@/pages/Live";
import Results from "@/pages/Results";
import MyBets from "@/pages/MyBets";
import WalletPage from "@/pages/Wallet";
import Admin from "@/pages/Admin";
import Racing from "@/pages/Racing";
import Lotto from "@/pages/Lotto";
import FlyHigh from "@/pages/FlyHigh";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <CurrencyProvider>
          <BetSlipProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="sport/:key" element={<SportPage />} />
                  <Route path="live" element={<Live />} />
                  <Route path="results" element={<Results />} />
                  <Route path="my-bets" element={<MyBets />} />
                  <Route path="wallet" element={<WalletPage />} />
                  <Route path="admin" element={<Admin />} />
                  <Route path="racing" element={<Racing />} />
                  <Route path="lotto" element={<Lotto />} />
                  <Route path="fly-high" element={<FlyHigh />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" />
          </BetSlipProvider>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
